import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { HomeOutlined, CloudSyncOutlined, TeamOutlined, FileTextOutlined, BarChartOutlined, ProductOutlined, GlobalOutlined, AppstoreAddOutlined, FilePdfOutlined, ToolOutlined, LogoutOutlined, ApartmentOutlined, ShopOutlined, SolutionOutlined, ShoppingCartOutlined, LineChartOutlined, UsergroupAddOutlined, SettingOutlined, AuditOutlined, FileDoneOutlined } from '@ant-design/icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandHoldingHeart, faTruck, faTag, faBuilding, faRulerCombined } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { logout, fetchApplications } from '../../store/auth/authSlice';
import './NavBodecom.css';

import poaService from "../../services/informe_poa/informe_poa_exportable";
import { exportAvancePoaExcel, exportReporteProductoExcel } from "../../utils/exportExcelPoa";


const NavBodecom = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector(state => state.auth.user);
    const isAdmin = user?.username === 'admin';
    const { applications, isAuthenticated } = useSelector(state => state.auth);
    useEffect(() => {
        if (isAuthenticated && applications.length === 0) {
            dispatch(fetchApplications());
        }
    }, [isAuthenticated, applications, dispatch]);

    const handleLogout = async () => {
        try {
            await dispatch(logout()).unwrap();
            navigate('/');
        } catch (error) {
            console.error('Error durante el logout:', error);
        }
    }; 

    const handleDownloadAvance = async () => {
        const data = await poaService.getInformeAvancePoa();
        await exportAvancePoaExcel(data);
    };

    const handleDownloadProducto = async () => {
        const data = await poaService.getInformeReporteProducto();
        await exportReporteProductoExcel(data);
    };
    const userApplications = applications.map(app => app.app_name);
    const informesPoaChildren = [
        {
            icon: <BarChartOutlined />,
            label: 'Informe de Avance POA',
            appName: 'poa-avance',
            onClick: handleDownloadAvance
        },
        {
            icon: <FileTextOutlined />,
            label: 'Reporte por Producto POA',
            appName: 'poa-reporte-producto',
            onClick: handleDownloadProducto
        }
    ].filter(item => userApplications.includes(item.appName));

    const menuItems = [
        { path: '/inicio', icon: <HomeOutlined />, label: 'Inicio', appName: 'inicio' },
        {
            label: 'Producto 1', appName: 'producto_1',
            children: [
                { path: '/buscar-proyecto', icon: <CloudSyncOutlined />, label: 'Actualización', appName: 'buscar-proyecto' },
                { path: '/es_proyectos', icon: <ApartmentOutlined />, label: 'Estructuración', appName: 'es_proyectos' },
            ],
        },
        {
            label: 'Producto 2', appName: 'producto_2',
            children: [
                {
                    label: (<span style={{ color: '#212529' }}> <SettingOutlined style={{ marginRight: 6 }} /> Implementación </span>),
                    children: [
                        { path: '/planOperativo', icon: <FontAwesomeIcon icon={faHandHoldingHeart} style={{ marginRight: 6 }} />, label: 'FAO', appName: 'planOperativo' },
                        { path: '#', icon: <TeamOutlined />, label: 'Organizaciones', appName: '', disabled: true },
                    ],
                },
            ],
        },
        {
            label: 'Producto 3', appName: 'producto_3',
            children: [
                { path: '/menu-curso-fortalecimiento', icon: <ProductOutlined />, label: 'Fort. Capacidades', appName: 'menu-curso-fortalecimiento' },
            ],
        },
        {
            label: 'Información General', appName: 'info_general',
            children: [
                {
                    label: (<span style={{ color: '#212529' }}> <BarChartOutlined style={{ marginRight: 8 }} /> Informe Participación </span>),
                    children: [
                        { path: '/participantes', icon: <UsergroupAddOutlined />, label: 'Participantes', appName: 'participantes' },
                        { path: '/novedad_participante', icon: <FileDoneOutlined />, label: 'Novedades', appName: 'novedad_participante' },
                        { path: '/ecas_participante', icon: <TeamOutlined />, label: 'Ecas', appName: 'ecas_participante' },
                        { path: '/visita_participante', icon: <TeamOutlined />, label: 'Visitas', appName: 'visita_participante' },
                    ],
                },
                { path: '/organizaciones', icon: <ShopOutlined />, label: 'Organizacional', appName: 'organizaciones' },
                { path: '/acuerdos-comerciales', icon: <ShoppingCartOutlined />, label: 'Comercial', appName: 'acuerdos-comerciales' },
                { path: '/caracterizacion', icon: <SolutionOutlined />, label: 'Caracterización', appName: 'caracterizacion' },
                { path: '/sistematizacionIppta', icon: <BarChartOutlined />, label: 'IPPTA', appName: 'sistematizacionIppta' },
                { path: '/encuestaEdah', icon: <LineChartOutlined />, label: 'Encuesta EDAH', appName: 'encuesta_EDAH' },
                { path: '/enfoqueGenero', icon: <TeamOutlined />, label: 'Enfoques Diferenciales', appName: 'enfoqueGenero' },
                {
                    label: (<span style={{ color: '#212529' }}> <AuditOutlined style={{ marginRight: 8 }} />  Plan de Acción </span>),
                    children: [
                        { path: '/planes-accion?tipo=1', icon: <TeamOutlined />, label: 'Ejecutados por FAO', appName: 'planes-accion-fao' },
                        { path: '/planes-accion?tipo=2', icon: <TeamOutlined />, label: 'Ejecutados por Organizaciones', appName: 'planes-accion-fao' },
                    ],
                },
            ],
        },
        {
            label: 'Seguimiento', appName: 'seguimiento',
            children: [{ path: '/poa', icon: <AppstoreAddOutlined />, label: 'POA', appName: 'poa' },
            { path: '/reportes', icon: <FilePdfOutlined />, label: 'Informes', appName: 'reportes' },
            { path: '/informe-actas', icon: <FilePdfOutlined />, label: 'Informes Actas de Entrega', appName: 'informe-actas' },
            { path: '/informe-ocr-actas', icon: <FileDoneOutlined />, label: 'OCR Actas de Entrega', appName: 'informe-ocr-actas' },
            ...(informesPoaChildren.length > 0 ? [{
                label: (<span style={{ color: '#212529' }}> <AuditOutlined style={{ marginRight: 8 }} />  Informes POA </span>),
                children: informesPoaChildren
            }] : [])
            ],
        },
        {
            label: 'Entregas', appName: 'financiero',
            children: [{ path: '/dashboard_financiero', icon: <LineChartOutlined />, label: 'Dashboard', appName: 'dashboard_financiero' },
            { path: '/productos_informe', icon: <FilePdfOutlined />, label: 'Informes de Productos', appName: 'productos_informe' },
            { path: '/productos_financiero', icon: <ProductOutlined />, label: 'Productos', appName: 'productos_financiero' },
            { path: '/entregas_financiero', icon: <FontAwesomeIcon icon={faTruck} style={{ marginRight: 6 }} />, label: 'Entregas', appName: 'entregas_financiero' },
            {
                label: (<span style={{ color: '#212529' }}> <FontAwesomeIcon icon={faTruck} style={{ marginRight: 6 }} /> Actas de entregas </span>),
                children: [
                    { path: '/financiero/proveedores', icon: <FontAwesomeIcon icon={faBuilding} style={{ marginRight: 6 }} />, label: 'Proveedores', appName: 'proveedores_ingresos_po' },
                    { path: '/financiero/ordenes-servicio', icon: <ProductOutlined />, label: 'Registro de productos', appName: 'ordenes_servicio_ingresos_po' },
                    { path: '/financiero/entregas', icon: <FontAwesomeIcon icon={faTruck} style={{ marginRight: 6 }} />, label: 'Entregas de productos', appName: 'entregas_ingresos_po' },
                ],
            },
            {
                label: (<span style={{ color: '#212529' }}> <ToolOutlined /> Configuración </span>),
                children: [{ path: '/estado_financiero', icon: <FontAwesomeIcon icon={faTag} style={{ marginRight: 6 }} />, label: 'Estado', appName: 'estado_financiero' },
                { path: '/proveedores_financiero', icon: <FontAwesomeIcon icon={faBuilding} style={{ marginRight: 6 }} />, label: 'Proveedores', appName: 'proveedores_financiero' },
                { path: '/unidad_medida_financiero', icon: <FontAwesomeIcon icon={faRulerCombined} style={{ marginRight: 6 }} />, label: 'Unidad Medida', appName: 'unidad_medida_financiero' }
                ],
            }
            ],
        },
        {
            label: 'Acceso', appName: 'acceso',
            children: [
                { path: '/reporte-seguimiento', icon: <AuditOutlined />, label: 'Log de Accesos', appName: 'reporte-seguimiento' },
            ],
        },
        ...(isAdmin
            ? [{
                label: 'Configuración', appName: 'app-admin',
                children: [
                    { path: '/procesar_edah_admin', icon: <AppstoreAddOutlined />, label: 'Procesar EDAH', appName: 'procesar_edah_admin' },
                    { path: '/app-slider', icon: <GlobalOutlined />, label: 'Configuración', appName: 'app-slider' },
                ],
            }]
            : []
        )
    ];


    const renderMenuItems = (items, parentKey = '') =>
        items.map((item, index) => {
            const itemKey = `${parentKey}-${item.appName || item.path || index}`;
            if (item.children) {
                return (
                    <NavDropdown
                        key={`parent-${itemKey}`}
                        title={item.label}
                        id={`dropdown-${itemKey}`}
                        className="nav-dropdown"
                    >
                        {item.children.map((child, childIndex) => {
                            const childKey = `${itemKey}-${child.appName || child.path || childIndex}`;
                            if (child.children) {
                                return (
                                    <NavDropdown
                                        key={`child-${childKey}`}
                                        title={child.label}
                                        id={`nested-dropdown-${childKey}`}
                                        className="nested-dropdown dropdown-menu-end"
                                    >
                                        {child.children.map((nestedChild, nestedIndex) => {
                                            const nestedKey = `${childKey}-${nestedChild.appName || nestedChild.path || nestedIndex}`;
                                            return (
                                                <NavDropdown.Item onClick={nestedChild.onClick}
                                                    key={`nested-${nestedKey}`}
                                                    as={Link}
                                                    to={nestedChild.path}
                                                    disabled={!userApplications.includes(nestedChild.appName)}
                                                    className={!userApplications.includes(nestedChild.appName) ? 'disabled-link' : ''}
                                                >
                                                    {nestedChild.icon} {nestedChild.label}
                                                </NavDropdown.Item>
                                            );
                                        })}
                                    </NavDropdown>
                                );
                            }
                            return (
                                <NavDropdown.Item
                                    key={`child-${childKey}`}
                                    as={Link}
                                    to={child.path}
                                    disabled={!userApplications.includes(child.appName)}
                                    className={!userApplications.includes(child.appName) ? 'disabled-link' : ''}
                                >
                                    {child.icon} {child.label}
                                </NavDropdown.Item>
                            );
                        })}
                    </NavDropdown>
                );
            }
            return (
                <Nav.Link
                    key={`link-${itemKey}`}
                    as={!userApplications.includes(item.appName) || item.disabled ? 'span' : Link}
                    to={!userApplications.includes(item.appName) || item.disabled ? undefined : item.path}
                    className={`nav-link ${!userApplications.includes(item.appName) || item.disabled ? 'disabled-link' : ''}`}
                >
                    {item.icon} {item.label}
                </Nav.Link>
            );
        });

    const filterMenuItems = (items) =>
        items
            .filter(item => {
                if (item.children) {
                    const filteredChildren = filterMenuItems(item.children);
                    return filteredChildren.length > 0;
                }
                return !item.appName || userApplications.includes(item.appName);
            })
            .map(item => ({
                ...item,
                children: item.children ? filterMenuItems(item.children) : undefined
            }));

    const filteredMenuItems = filterMenuItems(menuItems);
    return (
        <Navbar bg="light" expand="lg" className="mb-4 full-width-navbar pl-5">
            <div className="container-fluid">
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="mr-auto">
                        {applications.length === 0
                            ? <div>Loading applications...</div>
                            : renderMenuItems(filteredMenuItems)}
                        <Nav.Link onClick={handleLogout} className="nav-link">
                            <LogoutOutlined /> Salir
                        </Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </div>
        </Navbar>
    );
};

export default NavBodecom;
